import React from 'react';
import { BusinessForm } from './view/businessForm';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'BusinessForm',
  itemElt: (item, cmsOption) => <BusinessForm item={item} cmsOption={cmsOption} />
}